import $ from 'jquery';

function endpoint(template, search, replacement) {
    return template.replace(search, replacement);
}

function resetSelect($select, placeholder) {
    $select.empty();
    $select.append(new Option(placeholder, ''));
}

function fillSelect($select, placeholder, items) {
    resetSelect($select, placeholder);

    $.each(items, function (label, value) {
        $select.append(new Option(label, value));
    });
}

function toggleSelect($select, show, visibilityMode, hideUntilSelected) {
    var $parent = $select.parent();
    var blockedClasses = 'opacity-50 pointer-events-none';
    var visibleClasses = 'opacity-100';

    if (!hideUntilSelected) {
        $select.prop('disabled', false);
        $parent.removeClass('hidden invisible ' + blockedClasses);
        $parent.addClass(visibleClasses);
        $parent.removeAttr('hidden aria-hidden aria-disabled');
        return;
    }

    $select.prop('disabled', !show);

    if (visibilityMode) {
        $parent.removeClass('hidden invisible');
        $parent.removeAttr('hidden aria-hidden');
        $parent.toggleClass(blockedClasses, !show);
        $parent.toggleClass(visibleClasses, show);

        if (show) {
            $parent.removeAttr('aria-disabled');
        } else {
            $parent.attr('aria-disabled', 'true');
        }

        return;
    }

    $parent.removeClass(blockedClasses + ' ' + visibleClasses);
    $parent.toggleClass('hidden', !show);
    $parent.attr('hidden', !show);
}

export function setupEsLocationSelects($forms, options = {}) {
    var config = {
        provinceName: 'province_id',
        departmentName: 'department_id',
        cityName: 'city_id',
        onProvinceChange: null,
        onDepartmentChange: null,
        onCityChange: null,
        hideUntilSelected: true,
        visibilityMode: false,
        ...options,
    };

    $forms.each(function () {
        var $form = $(this);
        var $selectProvince = $form.find('select[name="' + config.provinceName + '"]');
        var $selectDepartment = $form.find('select[name="' + config.departmentName + '"]');
        var $selectCity = $form.find('select[name="' + config.cityName + '"]');

        if (!$selectProvince.length || !$selectDepartment.length || !$selectCity.length) {
            return;
        }

        var placeholders = {
            province: $selectProvince.find('option:first').text(),
            department: $selectDepartment.find('option:first').text(),
            city: $selectCity.find('option:first').text(),
        };

        resetSelect($selectDepartment, placeholders.department);
        resetSelect($selectCity, placeholders.city);
        toggleSelect($selectDepartment, false, config.visibilityMode, config.hideUntilSelected);
        toggleSelect($selectCity, false, config.visibilityMode, config.hideUntilSelected);

        $.get($form.data('provinces-url')).then(function (items) {
            fillSelect($selectProvince, placeholders.province, items);
        });

        $selectProvince.on('change', function () {
            resetSelect($selectDepartment, placeholders.department);
            resetSelect($selectCity, placeholders.city);
            toggleSelect($selectDepartment, false, config.visibilityMode, config.hideUntilSelected);
            toggleSelect($selectCity, false, config.visibilityMode, config.hideUntilSelected);

            if (typeof config.onProvinceChange === 'function') {
                config.onProvinceChange($form);
            }

            if (!$(this).val()) {
                return;
            }

            $.get(endpoint($form.data('departments-url'), '__province__', $(this).val())).then(function (items) {
                fillSelect($selectDepartment, placeholders.department, items);
                toggleSelect($selectDepartment, true, config.visibilityMode, config.hideUntilSelected);
            });
        });

        $selectDepartment.on('change', function () {
            resetSelect($selectCity, placeholders.city);
            toggleSelect($selectCity, false, config.visibilityMode, config.hideUntilSelected);

            if (typeof config.onDepartmentChange === 'function') {
                config.onDepartmentChange($form);
            }

            if (!$(this).val()) {
                return;
            }

            $.get(endpoint($form.data('cities-url'), '__department__', $(this).val())).then(function (items) {
                fillSelect($selectCity, placeholders.city, items);
                toggleSelect($selectCity, true, config.visibilityMode, config.hideUntilSelected);
            });
        });

        $selectCity.on('change', function () {
            if (typeof config.onCityChange === 'function') {
                config.onCityChange($form);
            }
        });
    });
}
